// extracted by mini-css-extract-plugin
export var divider = "_2m-0";
export var dividerText = "_2m-1";